(function () {
  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initAboutTimeline(root) {
    if (!root || root.dataset.timelineInit === 'true') return;
    root.dataset.timelineInit = 'true';

    var story = root.closest('.stl-about-story');
    var progressEl = root.querySelector('[data-timeline-progress]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-timeline-step]'));
    if (!steps.length) return;

    var activeIndex = -1;
    var ticking = false;
    var isSnapping = false;

    function snapLine() {
      if (story) {
        var custom = getComputedStyle(story).getPropertyValue('--tl-snap-line').trim();
        if (custom && custom.indexOf('vh') !== -1) {
          return (parseFloat(custom) / 100) * window.innerHeight;
        }
      }
      return window.innerHeight * 0.42;
    }

    function stepAnchorY(step) {
      var rect = step.getBoundingClientRect();
      return rect.top + rect.height * 0.35;
    }

    function inTimelineZone() {
      var first = steps[0].getBoundingClientRect();
      var last = steps[steps.length - 1].getBoundingClientRect();
      return last.bottom > snapLine() * 0.25 && first.top < window.innerHeight;
    }

    function pickActiveIndex() {
      var line = snapLine();
      var best = 0;
      var bestDist = Infinity;

      for (var i = 0; i < steps.length; i++) {
        var dist = Math.abs(stepAnchorY(steps[i]) - line);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }

      return best;
    }

    function setActiveStep(index) {
      steps.forEach(function (step, i) {
        var dist = Math.abs(i - index);
        step.classList.toggle('is-active', i === index);
        step.classList.toggle('is-near', dist === 1);
      });

      activeIndex = index;
    }

    function updateProgress(index) {
      if (!progressEl) return;
      var ratio = steps.length > 1 ? index / (steps.length - 1) : 0;
      progressEl.style.setProperty('--tl-progress', String(ratio));
    }

    function update() {
      ticking = false;
      var idx = pickActiveIndex();
      if (idx !== activeIndex) setActiveStep(idx);
      updateProgress(idx);
    }

    function onScroll() {
      if (!isSnapping) {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      }
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  function boot() {
    document.querySelectorAll('[data-about-timeline]').forEach(initAboutTimeline);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-about-timeline]');
    if (root) {
      delete root.dataset.timelineInit;
      initAboutTimeline(root);
    }
  });
})();
